// 更新用户信息
export const SET_USER = 'SET_USER';
